var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-key-expiration-table-cell"},[_c('div',{staticClass:"api-key-expiration-table-cell__date",class:_vm.keyStatus},[_c('div',{staticClass:"api-key-expiration-table-cell__date__container"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }